import { BoxOfferCard } from "@modules/boxOffer/components/boxOfferCard"
import { BoxOfferItemEntity } from "@modules/boxOffer/entities/boxOfferEntity"
import { StatusFilter } from "@modules/boxOffer/gateway/boxOfferDto"
import { useBoxOffers } from "@modules/boxOffer/hooks/useBoxOffer"
import { word } from "@modules/core/utils/i18n"
import { HUButton } from "@modules/ui/components/huButton"
import { InputText } from "primereact/inputtext"
import { useMemo, useState } from "react"

export type MemberSendOfferModalStepOneProps = {
  selectedOffer: BoxOfferItemEntity | null
  setSelectedOffer: (offer: BoxOfferItemEntity | null) => void
  handleStep: () => void
  onHide: () => void
}

export const MemberSendOfferModalStepOne: React.FC<MemberSendOfferModalStepOneProps> = ({
  selectedOffer,
  setSelectedOffer,
  handleStep,
  onHide,
}) => {
  const { data: offers } = useBoxOffers({ statusFilter: StatusFilter.ACTIVE })
  const [researchFilter, setGlobalFilter] = useState("")

  const filteredOffers = useMemo(() => {
    return offers.filter(
      (offer) =>
        offer.name.toLowerCase().indexOf(researchFilter.toLowerCase()) >= 0 ||
        (offer.description && offer.description.toLowerCase().indexOf(researchFilter.toLowerCase()) >= 0),
    )
  }, [researchFilter, offers])

  return (
    <div className="flex flex-column mt-3 w-full">
      {/* SEARCH BAR */}
      <div className=" flex w-full p-input-icon-left md:ml-auto align-content-center">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder={word("box.offer.send.modal.placeholder.inputName")}
          className="w-full"
          value={researchFilter}
        />
      </div>
      {/* OFFERS */}
      <div className="flex flex-column w-full gap-3 mt-3 h-25rem overflow-y-auto">
        {filteredOffers.length > 0 &&
          filteredOffers.map((offer) => (
            <BoxOfferCard
              offer={offer}
              key={offer.id}
              onClick={() => setSelectedOffer(offer)}
              className={`cursor-pointer flex w-full p-3 gap-4 border-round-xl border-1 justify-content-between ${selectedOffer?.id === offer.id ? "border-primary-700 bg-neutral-900" : "border-neutralColor-300"}`}
              style={{ minHeight: "9rem" }}
            />
          ))}
      </div>
      {/* BUTTON */}
      <div className="flex flex-row gap-2 mt-4 align-items-center justify-content-center">
        <HUButton
          type="Left_Icon"
          size="M"
          colorType="Quaternary"
          text={word("global.cancel")}
          onClick={onHide}
          className="w-full"
        />
        <HUButton
          type="Right_Icon"
          size="M"
          colorType="Primary"
          text={word("global.continue")}
          onClick={handleStep}
          disabled={!selectedOffer}
          className="w-full"
        />
      </div>
    </div>
  )
}
